module.exports = __webpack_public_path__ + "static/media/personality-tag.a0e55262.svg";